import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchProcess(params) {
  return await request({
    url: ENDPOINT.RECRUIMENT,
    method: "get",
    params,
  });
}

export async function fetchProcessById(id) {
  return await request({
    url: `${ENDPOINT.RECRUIMENT}/${id}`,
    method: "get",
  });
}

export async function createProcess(data) {
  return await request({
    url: ENDPOINT.RECRUIMENT,
    method: "post",
    data,
  });
}

export async function updateProcess(id, data) {
  return await request({
    url: `${ENDPOINT.RECRUIMENT}/${id}`,
    method: "post",
    data,
  });
}

export async function removeProcess(id) {
  return await request({
    url: `${ENDPOINT.RECRUIMENT}/${id}`,
    method: "delete",
  });
}